/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["@media screen{#print-content,#print-page-break,.print-content{display:none!important;visibility:hidden!important}}@media print{.p-dialog-width{width:100vw}}"];
export { styles as styles };

